import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { DOCUMENT, NgOptimizedImage, TitleCasePipe } from '@angular/common';
import { ContainerModel } from '@app/models/server/layout.model';
import { GoogleMapsModule } from '@angular/google-maps';
import { B2bDynamicLibModule } from '@app/b2b-dynamic-lib/b2b-dynamic-lib.module';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { IonContent, IonModal } from '@ionic/angular/standalone';
import { environment } from '@src/environments/environment';
import { DetailPageOlaMapComponent } from '@app/new-ui-lib/b2b-maps/detail-page-ola-map/detail-page-ola-map.component';
import { TapEffect } from '@app/components/directives/tap-effect.ts/tap-effect';
import { ToParagraphPipe } from '@app/components/pipes/to-paragraph/to-paragraph.pipe';
import { LoaderUtilService } from '@app/services/loader/loader-util.service';

// import { LoggerService } from '@app/services/util-services/logger.service';

@Component({
  selector: 'app-b2b-location-card',
  templateUrl: './b2b-location-card.component.html',
  styleUrls: ['./b2b-location-card.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    GoogleMapsModule,
    B2bDynamicLibModule,
    DetailPageOlaMapComponent,
    NgOptimizedImage,
    IonContent,
    IonModal,
    TapEffect,
    TitleCasePipe,
    ToParagraphPipe,
  ],
})
export class B2bLocationCardComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
  };

  @Input() isSeoPage: boolean;

  protected readonly environment = environment;

  // exploreLocations: ContainerModel[] = [];

  showMap: boolean = false;

  showErrorBlock: boolean;
  isDesktop: boolean = this.b2bDeviceUtilService.isDesktop();
  isServer: boolean = this.b2bDeviceUtilService.isServer();

  center: { lat: number; lng: number };

  canDismissModal: boolean = false;

  @ViewChild('mapModal') mapModal: IonModal;

  constructor(
    @Inject(DOCUMENT) private readonly document,
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private loaderUtilService: LoaderUtilService,
  ) {}

  ngOnInit() {
    if (this.compData?.container?.lat && this.compData?.container?.lng) {
      this.setCenter();
    } else {
      this.showErrorBlock = true;
    }
  }

  setCenter(): void {
    this.center = {
      lat: this.compData?.container?.lat,
      lng: this.compData?.container?.lng,
    };
  }

  /*fetchNearByLocations() {
    if (this.compData?.container?.containers?.length === 1) {
      const nearByContainer: ContainerModel =
        this.compData?.container?.containers[0];
      this.httpClientService
        .post(nearByContainer?.apiURL, {}, {})
        .pipe()
        .subscribe({
          next: (result: ContainerModel[]) => {
            this.exploreLocations = result;
            this.cdref.detectChanges();
          },
          error: (errorResponse: HttpErrorResponse) => {},
        });
    }
  }*/

  openMapModal() {
    this.loaderUtilService.show('Loading Map View', {
      backdrop: true,
      duration: 2200,
    });
    this.canDismissModal = false;
    if (this.mapModal) {
      this.mapModal.present().then();
    } else {
      if (!this.b2bDeviceUtilService?.isServer()) {
        setTimeout(() => {
          this.mapModal.present().then();
        }, 1000);
      }
    }
  }

  dismissMapModal() {
    this.canDismissModal = true;
    this.mapModal?.dismiss()?.then();
  }

  onShowMap() {
    this.loaderUtilService.show('Loading Map View', {
      backdrop: true,
      duration: 2200,
    });
    this.showMap = true;
  }
}
